import React from 'react';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import PeopleAltOutlined from '@material-ui/icons/PeopleAltOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ChecklistRtlOutlined from '@mui/icons-material/ChecklistRtlOutlined';
import ReceiptOutlined from '@material-ui/icons/ReceiptOutlined';
import AccountBalanceWalletOutlined from '@material-ui/icons/AccountBalanceWalletOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ManageAccountsOutlined from '@mui/icons-material/ManageAccountsOutlined';
import ShoppingCartOutlined from '@material-ui/icons/ShoppingCartOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import LocalMallOutlined from '@material-ui/icons/LocalMallOutlined';
import LinkOutlined from '@material-ui/icons/LinkOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import SummarizeOutlined from '@mui/icons-material/SummarizeOutlined';
import PermContactCalendarOutlined from '@material-ui/icons/PermContactCalendarOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SmsOutlined from '@material-ui/icons/SmsOutlined';
import HandymanOutlined from '@mui/icons-material/HandymanOutlined';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import PaymentIcon from '@material-ui/icons/Payment';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import MedicationIcon from '@mui/icons-material/Medication';
import {
  EmailOutlined,
  QuizOutlined,
  ReviewsOutlined,
  AccessTimeOutlined,
  AccountCircleOutlined,
  SubscriptionsOutlined,
  PeopleOutlineOutlined as PeopleOutlineIcon
} from '@mui/icons-material';
import BedroomParentOutlinedIcon from '@mui/icons-material/BedroomParentOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import NoteOutlinedIcon from '@mui/icons-material/NoteOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

const iconImage = require('../../../../assets/scss/icon/sidenav/Overview.svg');
const iconStyle = {
  fill: 'red'
};
const helloicon = () => (
  <>
    <img
      alt="helloicon"
      src={iconImage}
      style={iconStyle}
    />
  </>
);

const getNavigationConfig = (businessMaster_Id) => {
  const businessMasterId = businessMaster_Id || parseInt(localStorage.getItem('business_master_id'));

  return [
    {
      title: 'FITT LAB STUDIO',
      pages: [
        {
          title: 'Dashboard',
          href: '/fittlab/Dashboard',
          icon: DashboardOutlinedIcon
        },
        {
          title: 'Slot Requests',
          href: '/fittlab/customer_requests',
          icon: AccountCircleOutlined
        },
        {
          title: 'Slot Management',
          href: '/fittlab/slot_management',
          icon: AccessTimeOutlined
        },
        {
          title: 'Members Management',
          href: '/fittlab/gym-membership/total-member',
          icon: PeopleAltOutlined
        },
         {
          title: 'Membership Management',
          icon: SubscriptionsOutlined,
          href: '/fittlab/membership_management'
        },
        {
          title: 'Business Profile',
          href: '/fittlab/BusinessProfile',
          icon: BusinessCenterOutlinedIcon
        },
        {
          title: 'Transactions',
          href: '/fittlab/Transactions',
          icon: ReceiptOutlined
        },
        {
          title: 'Withdrawal',
          href: '/fittlab/Withdrawal',
          icon: AccountBalanceWalletOutlined
        },
        {
          title: 'Ticket',
          icon: ConfirmationNumberOutlinedIcon,
          href: '/Ticket'
        },
        {
          title: 'Inquiries',
          href: '/fittlab/inquiries',
          icon: QuizOutlined
        },
        {
          title: 'Subscription',
          icon: LocalAtmIcon,
          href: '/Subscription'
        },
        // {
        //   title: 'Transactions',
        //   href: '/PocketPay/gym/Transactions?t=g',
        //   icon: ReceiptOutlined
        // },
      ]
    },

    // ...(businessMasterId === 147
    //   ? [
    //     {
    //       title: 'HOTEL MANAGEMENT',
    //       pages: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/Dashboard',
    //           icon: DashboardOutlinedIcon
    //         },
    //         {
    //           title: 'Room Management',
    //           href: '/PocketPay/room_management',
    //           icon: BedroomParentOutlinedIcon
    //         },
    //         {
    //           title: 'Business Pricing',
    //           href: '/PocketPay/businessPackages',
    //           icon: Inventory2Icon
    //         },
    //         {
    //           title: 'Business Profile',
    //           href: '/PocketPay/BusinessProfile',
    //           icon: BusinessCenterOutlinedIcon
    //         },
    //         {
    //           title: 'Transactions',
    //           href: '/PocketPay/Transactions',
    //           icon: ReceiptOutlined
    //         },
    //         {
    //           title: 'Withdrawal',
    //           href: '/PocketPay/Withdrawal',
    //           icon: AccountBalanceWalletOutlined
    //         },
    //         {
    //           title: 'Ticket',
    //           icon: ConfirmationNumberOutlinedIcon,
    //           href: '/Ticket'
    //         },
    //         {
    //           title: 'Subscription',
    //           icon: LocalAtmIcon,
    //           href: '/Subscription'
    //         },
    //         {
    //           title: 'Reviews',
    //           href: '/PocketPay/reviews',
    //           icon: ReviewsOutlined
    //         },
    //         {
    //           title: 'Inquiries',
    //           href: '/PocketPay/inquiries',
    //           icon: QuizOutlined
    //         },
    //         {
    //           title: 'Hotel Management',
    //           href: '/PocketPay/hotel_management',
    //           icon: BedroomParentOutlinedIcon
    //         },
    //         {
    //           title: 'Membership Plans',
    //           href: '/PocketPay/Membership_Plans',
    //           icon: ReviewsOutlined
    //         }
    //       ]
    //     }
    //   ]
    //   : []),

    // ...(businessMasterId === 4
    //   ? [
    //     {
    //       title: 'HOSPITAL MANAGEMENT',
    //       pages: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/Dashboard',
    //           icon: DashboardOutlinedIcon
    //         },
    //         {
    //           title: 'Appointments',
    //           href: '/PocketPay/Appointments',
    //           icon: TodayOutlinedIcon
    //         },
    //         {
    //           title: 'OPD Management',
    //           href: '/PocketPay/doctor',
    //           icon: MedicationIcon
    //         },
    //         {
    //           title: 'Business Pricing',
    //           href: '/PocketPay/businessPackages',
    //           icon: Inventory2Icon
    //         },
    //         {
    //           title: 'Business Profile',
    //           href: '/PocketPay/BusinessProfile',
    //           icon: BusinessCenterOutlinedIcon
    //         },
    //         {
    //           title: 'Transactions',
    //           href: '/PocketPay/Transactions',
    //           icon: ReceiptOutlined
    //         },
    //         {
    //           title: 'Withdrawal',
    //           href: '/PocketPay/Withdrawal',
    //           icon: AccountBalanceWalletOutlined
    //         },
    //         {
    //           title: 'Ticket',
    //           icon: ConfirmationNumberOutlinedIcon,
    //           href: '/Ticket'
    //         },
    //         {
    //           title: 'Subscription',
    //           icon: LocalAtmIcon,
    //           href: '/Subscription'
    //         },
    //         {
    //           title: 'Reviews',
    //           href: '/PocketPay/reviews',
    //           icon: ReviewsOutlined
    //         },
    //         {
    //           title: 'Inquiries',
    //           href: '/PocketPay/inquiries',
    //           icon: QuizOutlined
    //         },
    //         {
    //           title: 'Membership Plans',
    //           href: '/PocketPay/Membership_Plans',
    //           icon: ReviewsOutlined
    //         },
    //         {
    //           title: 'Members List',
    //           href: '/PocketPay/members_list',
    //           icon: PeopleOutlineIcon
    //         }
    //       ]
    //     }
    //   ]
    //   : []),

    // ...(businessMasterId === 1
    //   ? [
    //     {
    //       title: 'DOCTOR MANAGEMENT',
    //       pages: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/Dashboard',
    //           icon: DashboardOutlinedIcon
    //         },
    //         {
    //           title: 'Appointments',
    //           href: '/PocketPay/Appointments',
    //           icon: TodayOutlinedIcon
    //         },
    //         {
    //           title: 'Business Pricing',
    //           href: '/PocketPay/businessPackages',
    //           icon: Inventory2Icon
    //         },
    //         {
    //           title: 'Business Profile',
    //           href: '/PocketPay/BusinessProfile',
    //           icon: BusinessCenterOutlinedIcon
    //         },
    //         {
    //           title: 'Transactions',
    //           href: '/PocketPay/Transactions',
    //           icon: ReceiptOutlined
    //         },
    //         {
    //           title: 'Withdrawal',
    //           href: '/PocketPay/Withdrawal',
    //           icon: AccountBalanceWalletOutlined
    //         },
    //         {
    //           title: 'Ticket',
    //           icon: ConfirmationNumberOutlinedIcon,
    //           href: '/Ticket'
    //         },
    //         {
    //           title: 'Subscription',
    //           icon: LocalAtmIcon,
    //           href: '/Subscription'
    //         },
    //         {
    //           title: 'Reviews',
    //           href: '/PocketPay/reviews',
    //           icon: ReviewsOutlined
    //         },
    //         {
    //           title: 'Inquiries',
    //           href: '/PocketPay/inquiries',
    //           icon: QuizOutlined
    //         },
    //         {
    //           title: 'Membership Plans',
    //           href: '/PocketPay/Membership_Plans',
    //           icon: ReviewsOutlined
    //         },
    //         {
    //           title: 'Members List',
    //           href: '/PocketPay/members_list',
    //           icon: PeopleOutlineIcon
    //         }
    //       ]
    //     }
    //   ]
    //   : []),

    // ...(businessMasterId === 166 || businessMasterId === 168
    //   ? [
    //     {
    //       title: 'VILLA MANAGEMENT',
    //       pages: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/villa_dashboard',
    //           icon: DashboardOutlinedIcon
    //         },
    //         {
    //           title: 'Villa Booking',
    //           href: '/PocketPay/villa_dashboard/all',
    //           icon: CalendarMonthOutlinedIcon
    //         },
    //         {
    //           title: 'Manage Villa',
    //           href: '/PocketPay/villa_manage',
    //           icon: BedroomParentOutlinedIcon
    //         },
    //       ]
    //     }
    //   ]
    //   : []),

    // ...((businessMasterId !== 166 && businessMasterId !== 147 && businessMasterId !== 168 && businessMasterId !== 165 && businessMasterId !== 164 && businessMasterId !== 4 && businessMasterId !== 1)
    //   ? [
    //     {
    //       pages: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/Dashboard',
    //           icon: DashboardOutlinedIcon
    //         },
    //         {
    //           title: 'Appointments',
    //           href: '/PocketPay/Appointments',
    //           icon: TodayOutlinedIcon
    //         }
    //       ]
    //     }
    //   ]
    //   : []),

    // ...(businessMasterId !== 165 && businessMasterId !== 164 && businessMasterId !== 147 && businessMasterId !== 4 && businessMasterId !== 1
    //   ? [
    //     {
    //       title: 'Business',
    //       pages: [
    //         {
    //           title: 'Business Profile',
    //           href: '/PocketPay/BusinessProfile',
    //           icon: BusinessCenterOutlinedIcon
    //         }
    //       ]
    //     }
    //   ]
    //   : []),

    // ...((businessMasterId !== 165 && businessMasterId !== 164 && businessMasterId !== 147 && businessMasterId !== 4 && businessMasterId !== 1) ? [{
    //   title: 'Pages',
    //   pages: [
    //     {
    //       title: 'Pocket Pay',
    //       href: '/MyQR',
    //       icon: PaymentIcon,
    //       children: [
    //         {
    //           title: 'Dashboard',
    //           href: '/PocketPay/Dashboard'
    //         },
    //         {
    //           title: 'Transactions',
    //           href: '/PocketPay/Transactions'
    //         },
    //         {
    //           title: 'Withdrawal',
    //           href: '/PocketPay/Withdrawal'
    //         },
    //         {
    //           title: 'Appointments',
    //           href: '/PocketPay/Appointments'
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Staff Management',
    //       href: '/staffmanagement',
    //       icon: AccountBalanceWalletIcon,
    //       children: [
    //         {
    //           title: 'Staff',
    //           href: '/staffmanagement/staff'
    //         },
    //         {
    //           title: 'Attendance',
    //           href: '/staffmanagement/staffattendance'
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Sales and Purchase',
    //       href: '/sales&purchase',
    //       icon: ReceiptIcon,
    //       children: [
    //         {
    //           title: 'Dashboard',
    //           href: '/sales&purchase/dashboard'
    //         },
    //         {
    //           title: 'Manage Party',
    //           href: '/sales&purchase/manage_party'
    //         },
    //         {
    //           title: 'Product Management',
    //           href: '/sales&purchase/product_management'
    //         },
    //         {
    //           title: 'Sale',
    //           href: '/sales&purchase/sale',
    //           children: [
    //             {
    //               title: 'Sale Invoices',
    //               href: '/sales&purchase/Sale/sale_invoices'
    //             },
    //             {
    //               title: 'Payment In',
    //               href: '/sales&purchase/Sale/payment_in'
    //             }
    //           ]
    //         },
    //         {
    //           title: 'Purchase',
    //           href: '/sales&purchase/purchase',
    //           children: [
    //             {
    //               title: 'Purchase Bills',
    //               href: '/sales&purchase/purchase/purchase_bills'
    //             },
    //             {
    //               title: 'Payment Out',
    //               href: '/sales&purchase/purchase/payment_out'
    //             }
    //           ]
    //         },
    //         {
    //           title: 'Payment links and send ',
    //           href: '/sales&purchase/payment_links_and_send'
    //         },
    //         {
    //           title: 'Reports',
    //           href: '/sales&purchase/reports',
    //           children: [
    //             {
    //               title: 'Sales',
    //               href: '/sales&purchase/reports/sales'
    //             },
    //             {
    //               title: 'Purchase',
    //               href: '/sales&purchase/reports/purchase'
    //             },
    //             {
    //               title: 'Profit & Loss',
    //               href: '/sales&purchase/reports/profit&loss'
    //             },
    //             {
    //               title: 'Party wise Profit & Loss',
    //               href: '/sales&purchase/reports/party_wise_profit&loss'
    //             }
    //           ]
    //         },
    //         {
    //           title: 'Settings',
    //           href: '/sales&purchase/settings'
    //         }
    //       ]
    //     },
    //     {
    //       title: 'Communication',
    //       href: '/Communication',
    //       icon: ChatIcon,
    //       children: [
    //         {
    //           title: 'Dashboard',
    //           href: '/Communication/dashboard'
    //         },
    //         {
    //           title: 'Contact Management',
    //           href: '/Communication/contact-management'
    //         },
    //         {
    //           title: 'SMS',
    //           href: '/Communication/sms',
    //           children: [
    //             {
    //               title: 'Compose SMS',
    //               href: '/Communication/sms/compose-sms'
    //             },
    //             {
    //               title: 'Bulk SMS',
    //               href: '/Communication/sms/bulk-sms'
    //             },
    //             {
    //               title: 'Report',
    //               href: '/Communication/sms/report'
    //             }
    //           ]
    //         }
    //       ]
    //     }
    //   ],
    //   ...(businessMasterId !== 147 && {
    //     title: 'Pocket Pay',
    //     pages: [
    //       {
    //         title: 'Transactions',
    //         href: '/PocketPay/Transactions',
    //         icon: ReceiptOutlined
    //       },
    //       {
    //         title: 'Withdrawal',
    //         href: '/PocketPay/Withdrawal',
    //         icon: AccountBalanceWalletOutlined
    //       },
    //       {
    //         title: 'Ticket',
    //         icon: ConfirmationNumberOutlinedIcon,
    //         href: '/Ticket'
    //       },
    //       {
    //         title: 'Subscription',
    //         icon: LocalAtmIcon,
    //         href: '/Subscription'
    //       },
    //       {
    //         title: 'Reviews',
    //         href: '/PocketPay/reviews',
    //         icon: ReviewsOutlined
    //       },
    //       {
    //         title: 'Inquiries',
    //         href: '/PocketPay/inquiries',
    //         icon: QuizOutlined
    //       },
    //       {
    //         title: 'Members List',
    //         href: '/PocketPay/members_list',
    //         icon: PeopleOutlineIcon
    //       },
    //       {
    //         title: 'Business Profile',
    //         href: '/PocketPay/BusinessProfile',
    //         icon: BusinessCenterOutlinedIcon
    //       }
    //     ]
    //   })
    // }] : []),
  ];
};

export default getNavigationConfig;
